import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../../store';

import style from '../../../../scss/profileList.scss';
import listStyle from '../../../../scss/list.scss';

import {
	fetchProfiles,
	selectAllProfiles,
} from '../../slices/profileSlice';
import {selectCurrentAccountId, selectCurrentProfileId, selectLanguage} from '../../selectors';

@customElement('arc-profiles-list')
export class ProfilesList extends connect(store)(LitElement) {

	static styles = [listStyle, style];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.status = state.status;
		this.lang = selectLanguage(state);
		this.profiles = selectAllProfiles(state);
		this.profileId = selectCurrentProfileId(state);
		this.accountId = selectCurrentAccountId(state);
	}

	connectedCallback() {
		super.connectedCallback();
		store.dispatch(fetchProfiles({isOwned: -1}));
	}

	disconnectedCallback() {
		super.disconnectedCallback();
	}

	render() {
		const state = store.getState();
		return html`

			<div class="list profilesList">
				<div class="listHeader">
					<div>${msg('Id')}</div>
					<div>${msg('Profile Name')}</div>
					<div>${msg('Owner')}</div>
					<div>${msg('Last Modified on')}</div>
					<div>${msg('Profile Permissions')}</div>
					<div>${msg('Artwork Permissions')}</div>
				</div>

				${repeat(
					this.profiles,
					(profile) => profile.id,
					(profile) => html`
						<arc-profiles-list-item .profile=${profile}></arc-profiles-list-item>
					`)}

			</div>
		`;
	}
}
